import { render, staticRenderFns } from "./Views.vue?vue&type=template&id=035d316c"
import script from "./Views.vue?vue&type=script&lang=js"
export * from "./Views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports